import {
    boolean,
    string,
    object,
    InferType,
    ObjectSchema,
} from "yup";
import * as yup from "yup";
import { AccessLevelEnum, CriarUsuariosContract } from "../contracts/criar-usuario.contract";

export const criarUsuarioSchema: ObjectSchema<CriarUsuariosContract> = object({
    fullName: string().required("Nome do Usuário é obrigatório"),
    email: string()
        .email("Formato de e-mail inválido")
        .required("E-mail do Usuário obrigatório"),
    cpf: string().required("CPF é obrigatório"),
    password1: yup
        .string()
        .required("A senha é obrigatória")
        .min(8, "A senha deve ter no mínimo 8 caracteres")
        .matches(/[!@#$%^&*(),.?":{}|<>]/, "A senha deve conter ao menos um caractere especial"),

    password2: yup
        .string()
        .required("Confirmação de senha é obrigatória")
        .oneOf([yup.ref("password1")], "As senhas não coincidem"),

    contact1: string().required("Contato 1 é obrigatório"),
    contact2: string().nullable().default(null),
    active: boolean().default(true),
    avatar: string().nullable().default(null),
    /*accessLevel: array()
        .of(
            mixed<AccessLevelEnum>()
                .oneOf(Object.values(AccessLevelEnum))
                .required("Nível de acesso é obrigatório")
        )
        .min(1, "Selecione ao menos um nível de acesso")
        .required("Nível de acesso é obrigatório"),*/
});

export type CriarUsuarioFormData = InferType<typeof criarUsuarioSchema>;
